import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/Button';
import { PlanForm } from '@/components/forms/PlanForm';
import { useCreatePlan } from '@/hooks/usePlans';

export const PlanCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const createMutation = useCreatePlan();

  const handleSubmit = async (data: Parameters<typeof createMutation.mutate>[0]) => {
    await createMutation.mutateAsync(data);
    navigate('/admin/plans');
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center gap-4">
        <Button variant="ghost" onClick={() => navigate('/admin/plans')}>
          <ArrowLeft className="w-4 h-4 mr-2" />
          Voltar
        </Button>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
          Criar Novo Plano
        </h1>
      </div>

      {/* Form */}
      <PlanForm
        onSubmit={handleSubmit}
        isLoading={createMutation.isPending}
      />
    </div>
  );
};

export default PlanCreatePage;
